import { SidebarViewState } from 'apps/aiAutomation/components/Layout/lib/types'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { getViewsPayloadDefaults, getViewsStateDefaults } from 'apps/aiAutomation/store/layout/lib'
import { KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

export interface AiAutomationLayoutState {
  isSidebarOpen: boolean
  isConfirmOpen: boolean
  showConfirm: boolean
  isSidebarExpanded: boolean

  interactiveView: SidebarViewType | null

  viewState: Record<SidebarViewType, SidebarViewState>
  viewPayload: ViewPayloadMap
}

export const AiAutomationLayoutInitialState: AiAutomationLayoutState = {
  isSidebarOpen: false,
  isConfirmOpen: false,
  showConfirm: false,
  isSidebarExpanded: false,

  interactiveView: null,

  viewState: getViewsStateDefaults(),
  viewPayload: getViewsPayloadDefaults(),
}

export interface ViewPayloadMap {
  [SidebarViewType.KNOWLEDGE_EDITOR]:
    | { newEntryType: KnowledgeEntryType; entryId?: never }
    | { newEntryType?: never; entryId: string }
    | null
  [SidebarViewType.ENGAGEMENT_GOAL_EDITOR]:
    | {
        goalType: GoalType | null
        goalId?: never
      }
    | {
        goalType?: never
        goalId: string
      }
    | null

  [SidebarViewType.INSTANT_ANSWERS]: null
  [SidebarViewType.POSITIVE_COMMENT_REPLIES]: null
  [SidebarViewType.TOV_SETUP]: null
  [SidebarViewType.AUTOMATION_READY_ROUTER]: null
  [SidebarViewType.KNOWLEDGE_ADDED]: null
  [SidebarViewType.GOAL_TYPE_PICKER]: null
  [SidebarViewType.KNOWLEDGE_ENTRY_TYPE_PICKER]: null
}

export type ViewPayload = {
  [View in keyof ViewPayloadMap]: Extract<ViewPayloadMap[View], null> extends never
    ? {
        view: View
        payload: ViewPayloadMap[View]
      }
    : Exclude<ViewPayloadMap[View], null> extends never
    ? { view: View }
    : {
        view: View
        payload?: ViewPayloadMap[View]
      }
}[SidebarViewType]
